import { Box, Flex, Modal, ModalContent, ModalOverlay, useDisclosure } from '@chakra-ui/react';
import { useEffect } from 'react';

import { TextBold, TextRegular } from 'UiKit/typography';
import { CloseIcon, LocationIcon, MicrophoneIcon } from 'Asset/icon';
import ButtonSolid from 'UiKit/button/buttonSolid';
import { Condition } from 'Component/others';
import { helpHostModalText } from 'Const/host-help-partner/view';
import useGetHelpRequestOperatorStatus from 'Domain/host-help-partner/useGetHelpRequestOperatorStatus';
import usePostAcceptRequest from 'Domain/host-help-partner/usePostAcceptRequest';

import useMonitoringState from 'View/monitoring/state';

import styles from './styles.module.css';
import useCaptchaSchedule from 'Store/captchaSchedule';

const HelpHostModal = () => {
  const { monitoringStatus } = useMonitoringState();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { triggerClear } = useCaptchaSchedule();

  const { data, isFetching: isLoadingHelpRequest } = useGetHelpRequestOperatorStatus(monitoringStatus);
  const { mutateAsync: onPostAcceptRequest } = usePostAcceptRequest();

  const helpRequest = data?.helpRequest;

  useEffect(() => {
    const isOpenHostModal = monitoringStatus?.status === 'CLOCKED_IN_ACTIVE' && data?.isOpen;

    if (isOpenHostModal) onOpen();
    else onClose();

    /* eslint-disable */
  }, [monitoringStatus, data]);

  const onSubmitRequest = async () => {
    await onPostAcceptRequest(helpRequest);
    triggerClear();
  };

  const isOpenModal = !isLoadingHelpRequest && isOpen;

  return (
    <Modal isOpen={isOpenModal} onClose={onClose}>
      <ModalOverlay />
      <ModalContent maxWidth="600px">
        <Box className={styles['help-host-modal__container']}>
          {/* Head */}

          <Flex className={styles['help-host__modal--head']}>
            <TextBold className={styles['title__text']}>{helpHostModalText.titleText}</TextBold>
            <CloseIcon size="18px" cursor="pointer" onClick={onClose} data-testid="close__icon--help-host" />
          </Flex>

          {/* Content */}

          <Box className={styles['help-host__modal--content']}>
            <TextRegular className={styles['content__text']}>{helpHostModalText.contentText}</TextRegular>
            <Flex className={styles['request-info__container']}>
              <Flex className={styles['request-info__item']}>
                <MicrophoneIcon color="var(--color-neutral60)" size="20px" />
                <Box>
                  <TextRegular className={styles['request-info__text--label']}>{helpHostModalText.hostText}</TextRegular>
                  <TextBold className={styles['request-info__text--value']}>{helpRequest?.hostName}</TextBold>
                </Box>
              </Flex>
              <Flex className={styles['request-info__item']}>
                <LocationIcon color="var(--color-neutral60)" size="20px" />
                <Box>
                  <TextRegular className={styles['request-info__text--label']}>{helpHostModalText.roomText}</TextRegular>
                  <TextBold className={styles['request-info__text--value']}>{helpRequest?.studioName}</TextBold>
                </Box>
              </Flex>
            </Flex>
            <Condition statement={helpRequest?.notes}>
              <Box className={styles['request-info__item']}>
                <TextRegular className={styles['request-info__text--label']}>{helpHostModalText.notesText}</TextRegular>
                <TextBold className={styles['request-info__text--value']}>{helpRequest?.notes}</TextBold>
              </Box>
            </Condition>
          </Box>

          {/* Footer */}

          <Box className={styles['help-host__modal--footer']}>
            <ButtonSolid onClick={onSubmitRequest} className={styles['help-host__button']}>
              {helpHostModalText.submitButtonText}
            </ButtonSolid>
          </Box>
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default HelpHostModal;
